import React, { useState } from "react";
import CountUp from "react-countup";

import {
    STextBackgroundLayer,
    STextStrokeLayer
} from './styles';

const TextDeco = ({
    value,
    size = "normal",
    isCountUp = false,
    hasPrefix = false,
    hasNoSuffixSpace = false,
}) => {
    const [randomNumber] = useState(Math.floor(Math.random() * Math.floor(10)));
    
    return (
        <STextStrokeLayer
            size={ size }
            hasPrefix={ hasPrefix }
            hasNoSuffixSpace={ hasNoSuffixSpace }
        >
            {
                isCountUp ? (
                    <>
                        <CountUp
                            start={ Number(value) - 30 > 0 ? Number(value) - 30 + randomNumber : 0 }
                            end={ Number(value) }
                            duration={ 3 }
                        />
                        <CountUp
                            className="second-text"
                            start={ Number(value) - 30 > 0 ? Number(value) - 30 + randomNumber : 0 }
                            end={ Number(value) }
                            duration={ 3 }
                        />
                    </>
                ) : (
                    <>
                        { value }
                        <STextBackgroundLayer
                            hasPrefix={ hasPrefix }
                        >
                            { value }
                        </STextBackgroundLayer>
                    </>
                )
            }
        </STextStrokeLayer>
    );
};

export default TextDeco;

